<template>
  <FinancialsOverviewCard
    title="Monthly Payment"
    :loading="isLoading"
    expandable
  >
    <template #default>
      <div
        v-if="currentSchedule.data"
        class="d-flex align-center text-truncate flex-wrap"
      >
        <h4 class="mr-3" :class="isMobile ? 'text-h5' : 'text-h4'">
          {{ currentSchedule.data.amountFormatted }}
        </h4>
        <SoStatus
          :status="{
            type: 'neutral',
            text: currentSchedule.data.paymentDayFormatted,
          }"
        />
      </div>
      <h4 v-else class="text-h4">No active payment schedules</h4>
    </template>
    <template #details>
      <p v-if="nextSchedule.data && nextSchedule.isFetched">
        Next payment of
        {{ formatMoney({ amount: nextSchedule.data.nextPayment }) }} on:
        <br />
        <strong>
          {{ formatDate(nextSchedule.data.nextPaymentDt) }}
          ({{ daysFromTodayFormatted(nextSchedule.data.nextPaymentDt) }})
        </strong>
      </p>

      <SoButton
        title="Payment schedule history"
        type="link"
        class="mt-4"
        @click="showHistoricSchedulesModal = true"
      />
    </template>
  </FinancialsOverviewCard>
  <HistoricSchedulesModal v-model="showHistoricSchedulesModal" />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import FinancialsOverviewCard from "../components/FinancialsOverviewCard.vue"
  import SoStatus from "@/components/SoStatus.vue"
  import HistoricSchedulesModal from "../modals/HistoricSchedulesModal.vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { formatMoney } from "@/helpers/moneyHelpers"
  import SoButton from "@/components/formControls/SoButton.vue"
  import { formatDate, daysFromTodayFormatted } from "@/helpers/dateHelper"

  export default defineComponent({
    components: {
      FinancialsOverviewCard,
      SoStatus,
      HistoricSchedulesModal,
      SoButton,
    },
    data() {
      return {
        formatMoney,
        formatDate,
        daysFromTodayFormatted,
        showHistoricSchedulesModal: false,
      }
    },
    computed: {
      isLoading() {
        return this.currentSchedule.isFetching || this.nextSchedule.isFetching
      },
      currentSchedule() {
        return useCurrentAccountStore().currentPaymentSchedule
      },
      nextSchedule() {
        return useCurrentAccountStore().nextPaymentSchedule
      },
      isMobile() {
        return this.$vuetify.display.mobile
      },
    },
  })
</script>
